export default __webpack_public_path__ + "static/media/Icons_Warning Icon.2b88d901.svg";